import React from 'react'
import { Link } from 'react-router-dom';
import { Button, Row } from 'reactstrap';
import nCount from '../assets/ncount.png';
function Home() {
  return (
    <div>
        <Row className='home-main-row'>
          <div className='home-main-div'>
          <img src={nCount} className='ncount-image mb-5'/>
          <h4 className='home-main-heading'>Rice Fallow Management Baseline Survey</h4>
          {/* <p >Sign In</p> */}
          <Link to="/register">
          {/* <button className='home-button mt-4'>Register</button> */}
          </Link>
          <Link to="/login">
          <button className='home-button mt-3'>Log In</button>
          </Link>
          {/* <p className='home-forget-password-button mt-2'>Forgot password?</p> */}
          </div>
        </Row>
    </div>
  )
}

export default Home